import React from 'react';
import { Label, Input, FormGroup } from 'reactstrap';
import i18n from '../../../../../i18next';

const TimePeriodSelection = props => {

    const { container, formGroupStyle, labelStyle } = styles;

    return (
        <div style={container}>
            <FormGroup style={formGroupStyle}>
                <Label for='always' style={labelStyle}>{i18n.t('screens:menuScreen.always')}</Label>
                <Input
                    type='radio' id='always'
                    name={`${props.screen}AvailableAllDay`}
                    value='always'
                    checked={props.itemAvailableAllDay ? true : false}
                    onChange={props.changeMenuOperationHours}
                />
            </FormGroup>

            <FormGroup style={formGroupStyle}>
                <Label for='custom' style={labelStyle}>{i18n.t('screens:menuScreen.custom')}</Label>
                <Input
                    type='radio' id='custom'
                    name={`${props.screen}AvailableAllDay`}
                    value='custom'
                    checked={props.itemAvailableAllDay ? false : true}
                    onChange={props.changeMenuOperationHours}
                />
            </FormGroup>
        </div>
    );
}

export default TimePeriodSelection;

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'row'
    },
    formGroupStyle: {
        display: 'flex',
        flexFlow: 'row-reverse', 
        justifyContent: 'space-between', 
        paddingRight: 20,
        marginBottom: '0px'
    },
    labelStyle: {
        position: 'relative',
        bottom: 2,
        paddingRight: 20,
        marginBottom: '0px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/availability/TimePeriodSelection.js